// extracted by mini-css-extract-plugin
module.exports = {"table-footer":"table-footer","level":"level","level-left":"level-left","level-right":"level-right","level-item":"level-item","color":"color","subtitle":"subtitle"};